function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.95763 172.242C5.0623 172.242 6.59714 172.352 7.88899 173.23C9.39691 174.245 10.1239 176 10.1239 177.673C10.1239 178.742 9.85467 180.387 8.37368 181.676C6.94654 182.91 5.30398 183.102 3.9839 183.102H2.74657V190.533H0V172.242H3.95763ZM2.74657 180.524H3.98521C6.3548 180.524 7.48574 179.345 7.48574 177.645C7.48574 176.629 7.08249 174.819 3.95829 174.819H2.74657V180.524Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9888 172.242V187.9H37.2665V190.533H29.2422V172.242H31.9888Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M67.3447 186.118H59.6699L57.7042 190.533H54.7422L63.682 171.173L72.1909 190.533H69.229L67.3447 186.118ZM66.2401 183.485L63.5743 177.287L60.8001 183.485H66.2401Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M94.8635 174.874V190.532H92.1163V174.874H87.9971V172.242H98.9833V174.874H94.8635Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M127.796 174.874H120.633V179.509H127.58V182.142H120.633V187.9H127.796V190.533H117.887V172.242H127.796V174.874Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M156.204 186.118H148.529L146.564 190.533H143.602L152.541 171.173L161.05 190.533H158.088L156.204 186.118ZM155.099 183.485L152.434 177.287L149.66 183.485H155.099Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M178.445 172.242V183.265C178.445 184.253 178.472 185.459 179.01 186.42C179.549 187.352 180.761 188.312 182.349 188.312C183.938 188.312 185.15 187.351 185.688 186.42C186.227 185.459 186.254 184.253 186.254 183.265V172.242H189V184.006C189 185.46 188.704 187.215 187.331 188.75C186.388 189.793 184.8 190.889 182.349 190.889C179.899 190.889 178.31 189.792 177.368 188.75C175.994 187.215 175.698 185.46 175.698 184.006V172.242H178.445Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M93.1553 64.8897L80.7393 57.743L38.4629 33.4092V96.3701L151.2 161.26V98.2987L128.652 85.3209L122.177 81.5945L106.105 72.3429L93.1553 64.8897Z",
  fill: "#463C64"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M93.1554 0L40.1387 30.5158L79.9012 53.4026L93.1554 61.0316V0Z",
  fill: "#00BEBE"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M122.178 77.7364V46.256L149.524 30.5158L96.5068 0V62.9609L106.775 68.8707L122.178 77.7364Z",
  fill: "#00BEBE"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M151.2 94.4408V33.4092L125.529 48.1848V79.6653L130.663 82.6205L151.2 94.4408Z",
  fill: "#463C64"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 191,
    viewBox: "0 0 189 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7ad2d4cf.svg";
export { ForwardRef as ReactComponent };